import Article from './ComposedArticle';
import { ArticleQuery } from './ArticleQuery.graphql';

Article.query = ArticleQuery;

export default Article;
